<template>
  <div class="header-wrapper">
    <div class="container-fluid">
        <div class="site-header row align-items-center">
            <div class="d-flex align-items-center col-8" data-respond>
                <h1 class="site-brand mb-0 mr-5">
                    <a href="javascript:;" class="site-link">
                        <img src="@/assets/images/logo.svg" alt="Learnova" class="site-logo">
                    </a>
                </h1>
                <div class="header-nav flex-grow-1 d-flex justify-content-between">
                    <ul class="header-menu nav mr-4">
                        <li class="menu-item">
                            <router-link :to="{ name: 'Info' }" class="nav-link">Thông tin</router-link>
                        </li>
                        <li class="menu-item">
                            <router-link :to="{ name: 'Courses' }" class="nav-link">Khóa học</router-link>
                        </li>
                        <li class="menu-item">
                            <router-link :to="{ name: 'Webinars' }" class="nav-link">Webinar</router-link>
                        </li>
                        <li class="menu-item">
                            <router-link :to="{ name: 'Statistics' }" class="nav-link">Thống kê</router-link>
                        </li>
                    </ul>
                    <!-- <button class="btn btn-icon btn-toggle d-none"><ion-icon name="menu" class="icon"></ion-icon></button> -->
                </div>
            </div>
            <div class="col-4 d-flex align-items-center justify-content-end">
              <ul class="header-icons-menu nav">
                  <li class="menu-item item-notification dropdown">
                      <a href="javascript:;" class="nav-link dropdown-toggle" role="button" id="notificationLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <ion-icon name="notifications-outline" class="align-middle"></ion-icon><span class="badge">0</span>
                      </a>
                  </li>
              </ul>

              <div v-if="user" class="user-panel d-flex align-items-center justify-content-end pl-3">
                  <b-dropdown class="btn-user rounded-sm d-flex align-items-center pl-3 pr-3 pt-2 pb-2">
                    <template v-slot:button-content>
                        <div class="nicename text-right"><strong>{{ user.fullname }}</strong></div>
                        <div class="avatar rounded-circle ml-2">
                            <img :src="user.pic | getMediaUrl" class="rounded-circle mw-100 mh-100" alt="">
                        </div>
                    </template>
                    <b-dropdown-item @click="handleLogout">Đăng xuất</b-dropdown-item>
                  </b-dropdown>
              </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },

  methods: {
    handleLogout() {
      this.$store
        .dispatch('user/logout')
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
    }
  }
}
</script>

<style lang="scss">
.header-wrapper {
  .nicename {
    font-size: 13px !important;
  }

  .user-panel {
    .btn-user {
      background-color: transparent;
      button {
        height: auto;
        display: flex;
        background-color: transparent;
        border: none;
        color: #333;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
